<script setup></script>

<template>
  <div class="text-bar">
    <span class="text-bar__content">
      <slot />
    </span>
  </div>
</template>

<style lang="scss" scoped>
  .text-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    background-color: #65a9d2;
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 1000;
    line-height: 1.2;

    opacity: 1;
    visibility: visible;

    &__content {
      font-size: 10px;
      color: #fff;
      font-weight: 600;
      text-align: center;
      width: fit-content;
      max-width: 100%;
      word-break: break-word;
    }
  }
</style>
